import React from 'react';

import { Skeleton } from '../../../skeleton/skeleton';

interface Props {
    count: number;
}

export const ColorOptionsSkeleton = ({ count }: Props) => (
    <ul className='bs-add-to-cart-drawer__color-options'>
        {Array.from({ length: count }).map((_, index) => (
            <li key={index}>
                <Skeleton className='bs-add-to-cart-drawer__color-item' />
            </li>
        ))}
    </ul>
);
